import axios from 'axios'
import { endpoint } from '../config'
//OUD
export function SEND_MESSAGE(message) {
    return {
        type: 'SEND_MESSAGE',
        payload: message
    }
}


export function SET_INBOX() {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user
            axios({
                url: `${endpoint}/api/chat/inbox`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                dispatch({
                    type: 'SET_INBOX',
                    payload: res.data.threads
                })
                resolve()
            })
        })
        
    }
}

export function SET_INBOX_PROMISE(token) {
    return new Promise((resolve, reject) => {
        axios({
            url: `${endpoint}/api/chat/inbox`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            }, 
        }).then(res => {
            resolve(res.data.threads)
        })
    })
}

export function GET_CHATS_PRIVATE(threadId) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user
            axios({
                url: `${endpoint}/api/chat/${threadId}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                resolve(res.data.data.messages)
            }).catch(reject)
        })
    }
}


export function ADD_CHAT_TO_PRIVATE_THREAD(message, threadId) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user
            const { text, image } = message
            const formData = new FormData()

            formData.append('text', text)
            if(image) {
                formData.append('imageFile', image)
            }
            axios({
                url: `${endpoint}/api/chat/${threadId}`,
                method: 'POST',
                data: formData,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'content-type': 'multipart/form-data',
                }, 
            }).then(res => {
                resolve(res.data.message)
            }).catch(reject)
        })
        
    }
}


export function CHECK_EXISTING_OR_NEW(friendId) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {

            const { token } = state().user.user
            axios({
                url: `${endpoint}/api/chat/exists`,
                method: 'POST',
                data: {
                    "user": {
                        "_id": friendId
                    }
                },
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }, 
            }).then(res => {
                resolve(res.data.data)
            }).catch(reject)
        })
    }
}

export function CREATE_NEW_PRIVATE_THREAD(message, user) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user
            const { text, image } = message
            const formData = new FormData()

            formData.append('text', text)
            formData.append('user', user._id)
            if(image) {
                formData.append('imageFile', image)
            }

            axios({
                url: `${endpoint}/api/chat`,
                method: 'POST',
                data: formData,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'content-type': 'multipart/form-data',
                }, 
            }).then(res => {
                resolve(res.data.data)
            }).catch(reject)
        })
    }
}